const transformCallToActionData = require("./transformCallToActionData");

module.exports = function transformSliderData(entity, sitemap) {
	const { relationships } = entity;

	let data = {
		id: entity.id,
		type: entity.type,
		slides: [],
	};

	if (relationships.field_slides && Array.isArray(relationships.field_slides.data)) {
		data.slides = relationships.field_slides.data.map((slide) => {
			return transformCallToActionData(slide, sitemap);
		});
	}
	return data;
};
